// extracted by mini-css-extract-plugin
export var active = "_f2-7";
export var blink = "_f2-8";
export var dropDownSelector = "_f2-4";
export var dropDownWrapper = "_f2-3";
export var fakeCursor = "_f2-6";
export var fontSizeButton = "_f2-9";
export var formQuillEditor = "_f2-0";
export var pressed = "_f2-a";
export var qlBlank = "_f2-1";
export var textFormattingToolbar = "_f2-2";
export var textToolbarOption = "_f2-5";